import * as types from './types';
import * as api from './api';

export const getProjects = () => ({
  type: types.GET_PROJECTS,
  payload: api.getProjects()
});

export const getProjectFiles = projectId => ({
  type: types.GET_PROJECT_FILES,
  payload: api.getProjectFiles(projectId),
  meta: {
    projectId
  }
});

export const selectEngagement = engagementId => ({
  type: types.SELECT_ENGAGEMENT,
  engagementId
});

export const state = newState => ({
  type: types.PROJECTS_SET_STATE,
  state: newState
});

export const createEngagement = engagementName => ({
  type: types.CREATE_ENGAGEMENT,
  payload: api.createEngagement(engagementName)
});

export const editEngagement = (engagementId, engagementName) => ({
  type: types.EDIT_ENGAGEMENT,
  payload: api.editEngagement(engagementId, engagementName)
});

export const deleteEngagement = engagementId => ({
  type: types.DELETE_ENGAGEMENT,
  payload: api.deleteEngagement(engagementId),
  meta: {
    engagementId
  }
});

export const deleteProject = projectId => ({
  type: types.DELETE_PROJECT,
  payload: api.deleteProject(projectId),
  meta: {
    projectId
  }
});

export const createProject = (
  projectId,
  projectName,
  engagementId,
  sourceLanguage,
  targetLanguage,
  workspace
) => ({
  type: types.CREATE_PROJECT,
  payload: api.createProject(
    projectId,
    projectName,
    engagementId,
    sourceLanguage,
    targetLanguage,
    workspace
  )
});

export const editProject = (
  projectId,
  projectName,
  engagementId,
  sourceLanguage,
  targetLanguage,
  workspace
) => ({
  type: types.EDIT_PROJECT,
  payload: api.editProject(
    projectId,
    projectName,
    engagementId,
    sourceLanguage,
    targetLanguage,
    workspace
  )
});

export const selectProject = project => ({
  type: types.SELECT_PROJECT,
  project
});

export const searchProjects = searchTerm => ({
  type: types.SEARCH_PROJECTS,
  searchTerm
});



// WEBPACK FOOTER //
// ./src/state/projects/actions.js